import React from 'react';
import { buildRecentMonths, formatYearMonthLabel } from '../../utils/salesProgress';

const inputFocus =
  'focus:ring-2 focus:ring-prodia-primary/30 focus:border-prodia-primary focus:outline-none';

export function StatsMonthSelect({ value, onChange, className = '' }) {
  const months = buildRecentMonths(13);
  return (
    <select
      value={value}
      onChange={onChange}
      className={`px-3 py-1.5 border border-prodia-border rounded-xl text-sm bg-prodia-surface ${inputFocus} ${className}`}
    >
      <option value="all">全期間</option>
      {months.map((month) => (
        <option key={month} value={month}>
          {formatYearMonthLabel(month)}
        </option>
      ))}
    </select>
  );
}

/** ヘッダー用: 営業月（過去13ヶ月・初期値は呼び出し側で当月） */
export function SalesMonthFilterSelect({ value, onChange, className = '', inputClassName = '' }) {
  const months = buildRecentMonths(13);
  return (
    <select
      value={value}
      onChange={onChange}
      className={`w-full px-4 py-3 border border-prodia-border rounded-xl bg-prodia-surface text-sm ${inputFocus} ${inputClassName} ${className}`}
    >
      {months.map((month) => (
        <option key={month} value={month}>
          {formatYearMonthLabel(month)}
        </option>
      ))}
    </select>
  );
}

export function StartMonthFilterSelect({
  value,
  onChange,
  monthOptions = [],
  className = '',
  inputClassName = '',
  allLabel = 'すべての月',
}) {
  return (
    <select
      value={value}
      onChange={onChange}
      className={`w-full px-4 py-3 border border-prodia-border rounded-xl bg-prodia-surface text-sm ${inputFocus} ${inputClassName} ${className}`}
    >
      <option value="all">{allLabel}</option>
      {monthOptions.map((month) => (
        <option key={month} value={month}>
          {month === '未定' ? '未定' : formatYearMonthLabel(month)}
        </option>
      ))}
    </select>
  );
}
